import { messagesReducer as messages } from './messages';
import { loadingSpinnerReducer as loader } from './loading-spinner';
import { questions } from './questions';
import { errorPageReducer as errorPage } from './error-page';
import { envConfigReducer as envConfig } from './configuration';

export { withRestorableDraft } from './restorable-draft';
export { EditAppointmentTitle } from './edit-appointment-title';
export {
  withLayout,
  withSidebarLayout,
  withSingleError,
  withProgressBar,
  withContainer,
  withHeadlineTitle,
  withHeadlineBackButton,
  Title,
  TitleWithSubtitle,
  containsMessage,
} from './layout';
export { withAnalytics } from './analytics';
export { withRequiredPrecondition } from './required-precondition';
export { Loader } from './loader';
export { ScreenNav } from './screen-nav';
export { EditRoute, withEditMode } from './edit-route';
export { RouteRender } from './route-render';
export { RouterOutlet } from './router-outlet';
export {
  Messages,
  errorTypes,
  successTypes,
  infoTypes,
  messagesActions,
  errorMessagesActions,
  ModalMessages,
  scrollToMessageTypeAnchor,
  errorMessages,
  successMessages,
  withMessageBanner,
} from './messages';
export { selectableItem, selectableCheckbox, selectableListItem } from './selectable-item';
export { preloadSteps } from './preload-steps';
export { persistToken } from './persist-token';

export { loadingSpinnerActions, apiCallFinished, LoadingSpinner } from './loading-spinner';
export {
  CalendarWithFilters,
  eligibleSlotsFilter,
  calendarSelectors,
  TimeSlotsSectionWithAccordion,
} from './calendar-with-filters';
export { CalendarTimeSlotsIntro } from './calendar-time-slots-intro';
export { ChosenPartner } from './chosen-partner';
export { ChosenPartnerDropdown } from './chosen-partner-dropdown';
export { ShopsSearchForm } from './shops-search-form';
export { SearchForm, SearchFormContext } from './search-form';
export { ShopsDropdown } from './shops-dropdown';
export { ManageTitle } from './manage-title';
export { Calendar } from './calendar';

export {
  SIZES_AND_AGE,
  HAIR_SKIN_EYES,
  ADDITIONAL_INFORMATION,
  YOUR_APPOINTMENT,
  withControls,
  Question,
  QuestionsGroup,
  DetailAction,
  questionsActions,
  questionHelpers,
  QuestionsSections,
} from './questions';

export { FormEditButtons, StateContext, states } from './form-edit-buttons';
export { PartnersIntro } from './partners-intro';
export { SelectablePartnerList } from './selectable-partner-list';
export { WarningModal, warningModalSelectors, CancelAppointmentModal } from './modal-window';
export { Section } from './section';
export { BookingReview, BookingContext, bookingView } from './booking-review';
export { AddToCalendarButton } from './add-to-calendar-button';
export { ReviewForm } from './review-form';
export { SectionItem, DateTimeDetails, ReviewDetails } from './review-details';
export { ReviewIntro } from './review-intro';
export { accordion, Accordion, AccordionItem, AccordionButton, AccordionPanel } from './accordion';
export { Media } from './media';

export { TermsAndConditionsNotice, TERMS_CONDITIONS_CONFIG } from './terms-and-conditions-notice';

export {
  AddressForm,
  SearchFormContainer,
  PostcodeSearchFormDescription,
} from './postcode-search-form';

export { ErrorPage, errorPageActions } from './error-page';

export { envConfigActions, envConfigSelectors, withConfig } from './configuration';

export const componentsReducers = {
  messages,
  loader,
  questions,
  errorPage,
  envConfig,
};
export { NotFound } from './not-found';
export { GoogleMap } from './google-map';
export { ConnectedProgressBar, progressBarConstants } from './progress-bar';
export { Banner } from './banner';
export { Grid } from './grid';
export { PatchTestSection, PATCH_TEST_CONFIG } from './patch-test-section';

export { withPreloadAppointment } from './preload-appointment';

export { ToggleButton } from './toggle-button';
export { Sticky } from './sticky';
export { withScrollTop } from './scroll-top';
export { FormFieldAdapter } from './form';
export { withDefaultHash } from './default-hash';
export { withTabTitle } from './tab-title';
export { withMeta } from './meta-attributes';

// fix webpack looping, do not remove
export { getServiceConfig } from '../ocab-services/services.config';
